export default __webpack_public_path__ + "static/staticHostingOg-cf2b42c7cee3370bb655ffbc388ddf72.jpg";